import { IPayerEngagementResponse } from "@wingspanhq/payments/dist/interfaces/api/payerPayeeEngagement";
import { IPayerRow } from "../../../services/search";
import { ISignedDocumentResponse } from "@wingspanhq/signed-documents/dist/lib/interfaces";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces/api/requirement";

export const QUERY_ALL_ENGAGEMENTS_BY_PAYER_IDS =
  "QUERY_ALL_ENGAGEMENTS_BY_PAYER_IDS";

export type IRequirementExtended = IRequirementResponse & {
  document?: ISignedDocumentResponse;
};

export type IPayerEngagementExtended = Omit<
  IPayerEngagementResponse,
  "requirements"
> & {
  requirements: IRequirementExtended[];
};

export type AllEngagementsByPayerIds = Array<{
  engagements: IPayerEngagementExtended[];
  payer: IPayerRow;
}>;
